import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Label,
    TabContent, TabPane, Nav, NavItem, NavLink
} from "reactstrap"
import classnames from 'classnames'

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import IndexBloc from '../Index/Blocs/IndexBloc'
import UpdateBloc from '../Update/Blocs/UpdateBloc'
import TugasComponent from './tab/TugasComponent'
import TanggungjawabComponent from './tab/TanggungjawabComponent'
import WewenangComponent from './tab/WewenangComponent'
import SyaratJabatanComponent from './tab/SyaratJabatanComponent'

// updateBloc = new UpdateBloc()
class UpdateView extends Component {
    indexBloc = new IndexBloc()
    updateBloc = new UpdateBloc()

    constructor(props) {
        super(props)
        this.state = {
            detail: [],
            list: [],
            dataForm: {},
            isLoading: 0,
            activeTab: '1',
        }

    }
    
    toggle = tab => {
        if(this.state.activeTab !== tab) this.setState({activeTab:tab});
    }

    loadDetail = async () => { //load jabatan info
        const query = {
            uuid: this.props.uuid
        }

        await this.updateBloc.fetchPositionInfo(query)
    }

    componentDidMount(){
        this.loadDetail()
        this.updateBloc.positionInfoChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ detail: result.data.response })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

    }
    componentWillUnmount() {
        this.indexBloc.detailChannel?.unsubscribe()
        this.indexBloc.updateChannel?.unsubscribe()
        this.updateBloc.positionInfoChannel?.unsubscribe()
    }
    
    render() {
        const { detail, list } = this.state
        return (
            <Fragment>
                <Container fluid>
                    <Card>
                        <CardBody>
                            <div className="float-end">
                                <Link to={`/master/syarat_jabatan.html`}>
                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                </Link>
                            </div>
                            <CardTitle>Detail Syarat Jabatan</CardTitle>
                            <hr/>
                            <CardTitle>Informasi Jabatan</CardTitle>
                            <hr/>

                            <Row className="mb-3">
                                <Label
                                    className="col-md-2 col-form-label text-right"
                                >
                                    Jabatan 
                                </Label>
                                <Col md="5">
                                    {detail?.position_name}
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Label
                                    className="col-md-2 col-form-label text-right"
                                >
                                    Tipe 
                                </Label>
                                <Col md="5">
                                    {detail?.type_name}
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Label
                                    className="col-md-2 col-form-label text-right"
                                >
                                    Eselon 
                                </Label>
                                <Col md="5">
                                    {detail?.echelon_name}
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Label
                                    className="col-md-2 col-form-label text-right"
                                >
                                    Unit 
                                </Label>
                                <Col md="5">
                                    {detail?.work_unit_name}
                                </Col>
                            </Row>
                            <hr />
                                
                            <div>
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: this.state.activeTab === '1' })}
                                            onClick={() => { this.toggle('1'); }}
                                        >
                                            Tugas
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: this.state.activeTab === '2' })}
                                            onClick={() => { this.toggle('2'); }}
                                        >
                                            Tanggung Jawab
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: this.state.activeTab === '3' })}
                                            onClick={() => { this.toggle('3'); }}
                                        >
                                            Wewenang
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: this.state.activeTab === '4' })}
                                            onClick={() => { this.toggle('4'); }}
                                        >
                                            Syarat Jabatan
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={this.state.activeTab}>
                                    <TabPane tabId="1">
                                        <Row>
                                            <Col sm="12">
                                                <div style={{padding:'15px'}}>
                                                    <TugasComponent uuid={this.props.uuid}></TugasComponent>
                                                </div>
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <Row>
                                            <Col sm="12">
                                                <TanggungjawabComponent uuid={this.props.uuid}></TanggungjawabComponent>
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="3">
                                        <Row>
                                            <Col sm="12">
                                                <WewenangComponent uuid={this.props.uuid}></WewenangComponent>
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="4">
                                        <Row>
                                            <Col sm="12">
                                                <SyaratJabatanComponent uuid={this.props.uuid}></SyaratJabatanComponent>
                                            </Col>
                                        </Row>
                                    </TabPane>
                                </TabContent>
                            </div>

                        </CardBody>
                    </Card>
                </Container>
                
            </Fragment>
        )
    }


}

export default UpdateView
